import React from "react"
import Banner from "./Banner"
import Typography from "./Typography"
import Video from "./Video"
import Website from "./Website"
import "./bakers-market.scss"

const BakersMarket = () => {
  return (
    <div>
      <Banner />
      <Website />
      <Typography />
      <Video />
    </div>
  )
}

export default BakersMarket
